/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerSetting } from './ScreenerSetting';
import {
    ScreenerSettingFromJSON,
    ScreenerSettingFromJSONTyped,
    ScreenerSettingToJSON,
    ScreenerSettingToJSONTyped,
} from './ScreenerSetting';

/**
 * 
 * @export
 * @interface GetScreenerSetting200Response
 */
export interface GetScreenerSetting200Response {
    /**
     * 
     */
    data?: ScreenerSetting;
}

/**
 * Check if a given object implements the GetScreenerSetting200Response interface.
 */
export function instanceOfGetScreenerSetting200Response(value: object): value is GetScreenerSetting200Response {
    return true;
}

export function GetScreenerSetting200ResponseFromJSON(json: any): GetScreenerSetting200Response {
    return GetScreenerSetting200ResponseFromJSONTyped(json, false);
}

export function GetScreenerSetting200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetScreenerSetting200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ScreenerSettingFromJSON(json['data']),
    };
}

export function GetScreenerSetting200ResponseToJSON(json: any): GetScreenerSetting200Response {
    return GetScreenerSetting200ResponseToJSONTyped(json, false);
}

export function GetScreenerSetting200ResponseToJSONTyped(value?: GetScreenerSetting200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ScreenerSettingToJSON(value['data']),
    };
}

